export const IsAuthenticated = () => {
  const token = localStorage.getItem("token");
  return token !== null;
};

export const trimTrailingZeros = (value) => {
  if (value === null || value === undefined || value === "") return "";
  return parseFloat(value).toString();
};

export const validatePassword = (password, confirmPassword) => {
  if (password === "" || confirmPassword === "") {
    return { message: "", className: "", isValid: false };
  }

  if (password !== confirmPassword) {
    return {
      message: "Passwords do not match",
      className: "invalid-feedback",
      isValid: false,
    };
  } else {
    return {
      message: "Password matched",
      className: "valid-feedback",
      isValid: true,
    };
  }
};

export const transformData = (resData) => {
  return {
    notes: resData.map((section) => ({
      section: section.name,
      custom_id: section.custom_id,
      notesdata: section.notes.map((noteItem) => ({
        note: noteItem.note,
        user: noteItem.User.username,
        updateAt: noteItem.updated_at,
        custom_id: noteItem.custom_id || undefined,
      })),
    })),
  };
};

export function formatToTitleCase(input = "") {
  return input
    .replace(/[_-]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export const getAbbreviation = (name) => {
  if (!name) return "";
  return name
    .split("-")
    .map((word) => word[0].toUpperCase())
    .join("");
};

export function formatRole(inputStr = "") {
  return inputStr.replace(/-/g, "").toLowerCase();
}

export const checkPermission = (allowedPermissions, permission) => {
  if (!allowedPermissions || !permission) return false;
  if (allowedPermissions?.includes("manage_all")) return true;
  return allowedPermissions?.includes(permission);
};

export function hasPermission(permissions, action) {
  return permissions.includes(action);
}

// export const checkPermission = (userPermissions, requiredPermission, requiredAction) => {
//   if (!userPermissions || !requiredPermission) return false;
//   // Check if the user has the required permission and the required action is in that permission
//   return userPermissions[requiredPermission]?.includes(requiredAction) || false;
// };

export const generateChainOfCustody = (
  vendors,
  type = "DS",
  isInvoiced = false,
  isPostpaid = false,
  apiVendor,
) => {
  const apiSteps = apiVendor?.OrderChainOfCustodies || [];

  const vendorSteps = (stepType) => {
    const seen = new Set();
    return vendors
      .filter((vendor) => {
        const name = vendor?.vendorPartner;
        if (seen.has(name)) return false;
        seen.add(name);
        return true;
      })
      .map((vendor) => ({
        name: `Vendor ${vendor?.vendorPartner} ${stepType}`,
      }));
  };

  let generatedSteps = [];
  if (type === "DS") {
    generatedSteps = [
      ...vendorSteps("PO Issued"),
      ...vendorSteps("Products Shipped to Customer"),
      ...vendorSteps("Products Delivered to Customer"),
      ...vendorSteps("Bill Issued"),
      ...vendorSteps("Bill Paid"),
    ];
  } else if (type === "CRK" || type === "KIT" || type === "S") {
    generatedSteps = [
      ...vendorSteps("PO Issued"),
      ...vendorSteps("Products Reached Aspetto Warehouse"),
      ...vendorSteps("Products Shipped to Customer"),
      ...vendorSteps("Products Delivered to Customer"),
      ...vendorSteps("Bill Issued"),
      ...vendorSteps("Bill Paid"),
    ];
  } else if (type === "M") {
    generatedSteps = [
      ...vendorSteps("PO Issued"),
      ...vendorSteps("Products Reached Aspetto Warehouse"),
      ...vendorSteps("Products Shipped to Customer"),
      ...vendorSteps("Products Delivered to Customer"),
      ...vendorSteps("Bill Issued"),
      ...vendorSteps("Bill Paid"),
    ];
  }

  const isPrepaid = !isInvoiced && !isPostpaid;

  const prePaidStep = isPrepaid
    ? [{ name: "Customer Card Charged" }, { name: "Sales Receipt Generated" }]
    : [];
  const invoiceSteps = isInvoiced
    ? [{ name: "Customer Invoice Issued" }, { name: "Customer Invoice Paid" }]
    : [];
  const postPaidSteps = isPostpaid
    ? [{ name: "Customer Card Charged" }, { name: "Sales Receipt Generated" }]
    : [];
  const allGenerated = [
    ...prePaidStep,
    ...generatedSteps,
    ...invoiceSteps,
    ...postPaidSteps,
  ];

  // console.log("allGenerated",allGenerated)
  // Map generated by name
  const generatedStepMap = {};
  for (const step of allGenerated) {
    generatedStepMap[step.name] = step;
  }

  // console.log("generatedStepMap", generatedStepMap)

  const apiStepNames = new Set(apiSteps.map((step) => step.name));

  // console.log("apiSteps", apiSteps)

  const orderedFromApi = apiSteps.filter((step) => {
    const base = generatedStepMap[step.name] || {};
    if (
      (step.is_custom === false && base.hasOwnProperty("name")) ||
      step.is_custom === true
    )
      return {
        ...base,
        ...step,
      };
  });

  // console.log("orderedFromApi",orderedFromApi)

  const newSteps = allGenerated
    .filter((step) => !apiStepNames.has(step.name))
    .map((step) => ({
      ...step,
      due_date: null,
      role_id: 0,
      person_id: 0,
      check_status: false,
      is_custom: false,
      is_deleted: false,
    }));

  const finalSteps = [...orderedFromApi, ...newSteps];

  // console.log("finalSteps", finalSteps)

  if (finalSteps.length === 0) {
    return allGenerated.map((step) => ({
      ...step,
      due_date: null,
      role_id: 0,
      person_id: 0,
      check_status: false,
      is_custom: false,
      is_deleted: false,
    }));
  }

  return finalSteps;
};

export const paymentChain = [
  {
    name: "Customer Paid",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Shipped to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Delivered to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Bill Issued",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Bill Paid",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Consolidate / Re-Pack / Kit",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] PO Issued",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Order Reached Aspetto Warehouse",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Delivered to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Manufacturing",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Manufacturing Started",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Manufacturing Successfully Completed",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Shipped to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Delivered to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
];

export const InvoicedChain = [
  {
    name: "Customer Paid",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Shipped to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Delivered to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Bill Issued",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Bill Paid",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Consolidate / Re-Pack / Kit",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] PO Issued",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Order Reached Aspetto Warehouse",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Delivered to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Manufacturing",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Manufacturing Started",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Manufacturing Successfully Completed",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Shipped to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Vendor [Vendor Name] Products Delivered to Customer",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Customer Invoice Issued",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
  {
    name: "Customer Invoice Paid",
    due_date: null,
    role_id: 0,
    person_id: 0,
    check_status: false,
    is_custom: false,
    is_deleted: false,
  },
];

// export const shouldHideSubstatus = (row, value) => {

//   const warehouseStatuses = [
//     "In-Transit-to-Warehouse",
//     "At-Warehouse",
//     "Warehouse-Ready-to-Ship",
//   ];

//   const prePaymentStatuses = ["Pre-Payment-Pending"];
//   const postPaymentStatuses = ["Post-Payment-Pending"];

//   // 1️⃣ Dropship rule
//   if (row?.order_type === "DS" && warehouseStatuses.includes(value)) {
//     return true;
//   }

//   // 2️⃣ Payment type rules
//   if (row?.order_payment_type === "pre-paid" && postPaymentStatuses.includes(value)) {
//     return true;
//   }

//   if (row?.order_payment_type === "invoiced" &&
//       postPaymentStatuses.includes(value)) {
//     return true;
//   }

//   if (row?.order_payment_type === "post-paid" && prePaymentStatuses.includes(value)) {
//     return true;
//   }

//   return false;
// };

// export const shouldHideSubstatus = (row, value) => {
//   const warehouseStatuses = [
//     "In-Transit-to-Warehouse",
//     "At-Warehouse",
//     "Warehouse-Ready-to-Ship",
//   ];

//   const prePaymentStatuses = ["Pre-Payment-Pending"];
//   const postPaymentStatuses = ["Post-Payment-Pending"];

//   // 1️⃣ Dropship rule
//   if (row?.order_type === "DS" && warehouseStatuses.includes(value)) {
//     return true;
//   }

//   // 2️⃣ Payment type rules

//   // Pre-paid → hide post-payment
//   if (
//     row?.order_payment_type === "pre-paid" &&
//     postPaymentStatuses.includes(value)
//   ) {
//     return true;
//   }

//   // Post-paid → hide pre-payment
//   if (
//     row?.order_payment_type === "post-paid" &&
//     prePaymentStatuses.includes(value)
//   ) {
//     return true;
//   }

//   // Invoiced → hide both pre & post payment pending (only show PO-Pending)
//   if (
//     row?.order_payment_type === "invoiced" &&
//     (prePaymentStatuses.includes(value) ||
//       postPaymentStatuses.includes(value))
//   ) {
//     return true;
//   }

//   return false;
// };

export const shouldHideSubstatus = (row, value) => {
  const warehouseStatuses = [
    "In-Transit-to-Warehouse",
    "At-Warehouse",
    "Warehouse-Ready-to-Ship",
  ];

  const prePaymentStatuses = ["Pre-Payment-Pending"];
  const postPaymentStatuses = ["Post-Payment-Pending"];
  const invoicePaymentStatuses = ["Invoice-Payment-Pending"];
  const invoicePending = ["Invoice-Pending"]

  // if (row?.order_type === "DS" && warehouseStatuses.includes(value)) {
  //   return true;
  // }
  if (
    (row?.order_type === "DS" && warehouseStatuses.includes(value)) ||
    (row?.order_type === "S" && value === "In-Transit-to-Warehouse")
  ) {
    return true;
  }

  if (
    row?.order_payment_type === "pre-paid" &&
    (postPaymentStatuses.includes(value) ||
      invoicePaymentStatuses.includes(value))
  ) {
    return true;
  }

  if (
    row?.order_payment_type === "post-paid" &&
    (prePaymentStatuses.includes(value) ||
      invoicePaymentStatuses.includes(value))
  ) {
    return true;
  }

  if (
    row?.order_payment_type === "invoiced" &&
    (prePaymentStatuses.includes(value) || postPaymentStatuses.includes(value))
  ) {
    return true;
  }

  return false;
};
